import { render, staticRenderFns } from "./common-nav.vue?vue&type=template&id=57ec5c9c"
import script from "./common-nav.vue?vue&type=script&lang=js"
export * from "./common-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports